import { gapi } from 'auth';
import { useEffect } from 'react';

function GoogleLoginButton() {
  const onGoogleFailure = () => {
    alert('Google Sign In Failed');
  };

  useEffect(() => {
    try {
      gapi()?.signin2.render('my-signin2', {
        onfailure: onGoogleFailure,
      });
    } catch (error) {}
  }, []);

  return <div id="my-signin2"></div>;
}

export default GoogleLoginButton;
